import React from 'react';
import './ui.css';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';
  size?: 'sm' | 'md';
  pulseDot?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'neutral',
  size = 'md',
  pulseDot = false,
  className = '',
  style = {},
}) => {
  return (
    <span className={`badge badge-${variant} badge-${size} ${className}`} style={style}>
      {pulseDot && <span className="badge-pulse-dot" />}
      <span>{children}</span>
    </span>
  );
};

export interface AvatarProps {
  name: string;
  size?: 'sm' | 'md' | 'lg';
  src?: string | null;
  statusDot?: 'ACTIVE' | 'SUSPENDED' | 'OFFLINE';
}

export const Avatar: React.FC<AvatarProps> = ({ name, size = 'md', src, statusDot }) => {
  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .substring(0, 2)
    .toUpperCase();

  return (
    <div className={`avatar avatar-${size}`}>
      {src ? (
        <img src={src} alt={name} className="avatar-img" />
      ) : (
        <span className="avatar-initials">{initials}</span>
      )}
      {statusDot && <span className={`avatar-status-dot status-${statusDot.toLowerCase()}`} />}
    </div>
  );
};
